const routesPaths = {
  prescriberEdit: '/:prescriberId/edit/',
  prescriberNew: '/new',
  prescribers: '/',
};

export default routesPaths;
